import { Box, Button, Typography } from '@mui/material';
import { ArrowDropDownIcon, DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import React, { useEffect, useRef, useState } from 'react'
import { ApiGetMonthlyComparison, ApiMonthlyReport } from '../../apiService/Core/Apicall';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { useSelector } from 'react-redux';
import { RootState } from '../../global/config/store';
import storage from '../../utils/storage';



pdfjs.GlobalWorkerOptions.workerSrc = '//cdnjs.cloudflare.com/ajax/libs/pdf.js/4.8.69/pdf.worker.min.js';
function ComparisonsDownload() {
    const selectedMonth = useSelector((state: RootState) => state.month.selectedMonth)
    const [pdfUrl, setPdfUrl] = useState<string | null>(null);
    const [monthlyreportyear, setmonthlyreportyear] = useState<any>(dayjs(selectedMonth))
    const clientEntity = useSelector((state: RootState) => state.clientEntity.selectedEntity)
    const {isWholeGroup, clientEntityIds} = useSelector((state: RootState) => state.wholegroup)
    
    //   const ref = useRef();




    const downloadMonthlyReport = async () => {
        const data = `?clientEntityId=${storage.getItem('clientEntityId')}&isClientEntityIdRequired=true&month=${monthlyreportyear.month() + 1}&year=${monthlyreportyear.year()}&type=comparisonDownload${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`;
        const data2 = `?clientEntityId=${isWholeGroup ? clientEntityIds : storage.getItem('clientEntityId')}&month=${monthlyreportyear.month() + 1}&year=${monthlyreportyear.year()}&type=monthlyDonwload${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`;


        try {
            const response = await ApiGetMonthlyComparison(data2);

            const blob = new Blob([response.data], { type: 'application/pdf' });

            if (blob.size === 0) {
                throw new Error("Empty PDF file.");
            }
            const url = URL.createObjectURL(blob);
            setPdfUrl(url); // this will trigger rendering the PDF
        } catch (error: any) {
            // toast.error("Failed to load PDF: " + error);
        }
    };
    const handledownloadMonthlyReport = async () => {
        const data = `?clientEntityId=${storage.getItem('clientEntityId')}&isClientEntityIdRequired=true&month=${monthlyreportyear.month() + 1}&year=${monthlyreportyear.year()}&type=comparisonDownload${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`;
        const data2 = `?clientEntityId=${ isWholeGroup ? clientEntityIds : storage.getItem('clientEntityId')}&month=${monthlyreportyear.month() + 1}&year=${monthlyreportyear.year()}&type=monthlyDonwload${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`;


        try {
            const response = await ApiGetMonthlyComparison(data2);

            const blob = new Blob([response.data], { type: 'application/pdf' });

            if (blob.size === 0) {
                throw new Error("Empty PDF file.");
            }
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `Monthly_Comparison_Report_${storage.getItem('clientEntityName') ? storage.getItem('clientEntityName') : ''}_${monthlyreportyear.month() + 1}_${monthlyreportyear.year()}.pdf`; // custom file name
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (error: any) {
            // toast.error("Failed to load PDF: " + error);
        }
    };

    useEffect(() => {
        downloadMonthlyReport()
    }, [monthlyreportyear, clientEntity, isWholeGroup])

    useEffect(() => {
        return () => {
            if (pdfUrl) URL.revokeObjectURL(pdfUrl);
        };
    }, [pdfUrl]);

    useEffect(() => {
        setmonthlyreportyear(dayjs(selectedMonth))
    }, [selectedMonth])

    return (
        <Box>

            <Box className='mt-3 d-flex align-items-center justify-content-between mb-3'>
                <Typography className='fw-bold' variant='h6'>Monthly Comparison</Typography>
                <Box width={{ xs: '75%', md: 'fit-content' }} maxWidth='170px' className='d-flex align-items-center justify-content-end'>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker value={monthlyreportyear}
                            sx={{ justifyContent: 'end' }}
                            label='Month: '
                            views={['month', 'year']}
                            format="MMM-YY"
                            onChange={(e) => { setmonthlyreportyear(e); }}

                            slots={{
                                openPickerIcon: ArrowDropDownIcon,
                            }}
                        />
                    </LocalizationProvider>
                </Box>
            </Box>
            <Box className='d-flex justify-content-end my-1 mb-2'>
                <Button className='button-primary' onClick={() => { handledownloadMonthlyReport() }}>Download</Button>
            </Box>
            {pdfUrl && (
                // <Document
                //     file={`/proxy-pdf?url=https://external.com/sample.pdf`}
                //     onLoadError={(error) => console.error('PDF load error:', error)}
                //     onSourceError={(error) => console.error('Source error:', error)}
                // >
                //     <Page pageNumber={1} />
                // </Document>

                <iframe
                    src={pdfUrl + "#toolbar=0"}
                    title="Monthly Report PDF"
                    width="100%"
                    height="700px"
                    style={{ border: 'none' }}
                />
            )}
        </Box>
    )
}

export default ComparisonsDownload
